// extracted by mini-css-extract-plugin
export var activityContainer = "_fz-0";
export var typingIndicatorContainer = "_fz-1";
export var typingIndicatorDot = "_fz-2";
export var wave = "_fz-3";